const url = window.location.href.substring(0,window.location.href.lastIndexOf("/") + 1);
export default url;